import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use FileType from application-types instead.
 */
export class FileType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'File';

  friendlyName = 'File';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];

  get default(): any {
    return {};
  }

  superUserOnly = true;

  buildSchema() {
    return yup.object().nullable().default(null);
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use File from application-types instead.
 */
const definition = new FileType();

Types.addBaseType(definition);
export default definition;
